var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { persistNSync } from 'persist-and-sync';
var initialContactState = {
    agents: { data: [], favoriteAgents: [] },
    skills: { data: [] },
    teams: { data: [] },
    addressBookEntries: { data: [], allAddressBookEntries: [] },
    contactLoading: false
};
export var useContactStore = create()(subscribeWithSelector(persistNSync(function (set) { return (__assign(__assign({}, initialContactState), { setAgents: function (agents) { return set({ agents: agents }); }, setSkills: function (skills) { return set({ skills: skills }); }, setTeams: function (teams) { return set({ teams: teams }); }, setAddressBookEntries: function (entries) { return set({ addressBookEntries: entries }); }, setContactLoading: function (loading) { return set({ contactLoading: loading }); }, resetContact: function () { return set(initialContactState); } })); }, {
    name: 'nic-contact-store',
    storage: 'localStorage',
    exclude: [/^set/, /^reset/]
})));
// Selectors
export var selectAgents = function (state) {
    return state.agents.data || [];
};
export var selectSkills = function (state) {
    return state.skills.data || [];
};
export var selectTeams = function (state) {
    return state.teams.data || [];
};
export var selectAddressBookEntries = function (state) { return state.addressBookEntries.allAddressBookEntries || []; };
export var selectLoading = function (state) {
    return state.contactLoading;
};
